import { TableCell, TableRow } from '@mui/material'
import React, { useState } from 'react'
import EditIcon from '@mui/icons-material/Edit';
import PrintIcon from '@mui/icons-material/Print'
import { focusElemnt, getFloat, navigation3 } from '../../../common/helper';
import LineinputV2 from '../../../common/lineinputV2';
import CustomTooltip from '../../../common/CustomTooltip';
import * as id from '../common/AcountingId'
import moment from 'moment';

const CargoMemoBody = ({ getPrintData, isEdit, setIsEdit, tableData, printReport, val, index, handleTableData }) => {
    const [updateData, setUpdateData] = useState({
        OtherChgManualLess: val?.OtherChgManualLess,
        OtherChgManualAdd: val?.OtherChgManualAdd,
    })
    return (
        <TableRow key={`TD-${index}`} className='BusAndCargo'>
            <TableCell sx={{ height: '36px', textAlign: 'right', fontSize: '12px', minWidth: '40px', color: '#444', fontWeight: '500' }}>{index + 1}</TableCell>
            <TableCell sx={{ height: '36px', textAlign: 'left', fontSize: '12px', minWidth: '80px', color: '#444', fontWeight: '500' }}>{val.VoucherNo}</TableCell>
            <TableCell sx={{ height: '36px', textAlign: 'left', fontSize: '12px', minWidth: '110px', color: '#444', fontWeight: '500' }}>{val.BusMasterNumber}</TableCell>
            <TableCell sx={{ height: '36px', textAlign: 'left', fontSize: '12px', minWidth: '100px', color: '#444', maxWidth: '100px', fontWeight: '500' }}>
                <CustomTooltip title={val?.FromCity} data={val?.FromCity} placement={'bottom-start'} />
            </TableCell>
            <TableCell sx={{ height: '36px', textAlign: 'left', fontSize: '12px', minWidth: '100px', color: '#444', maxWidth: '100px', fontWeight: '500' }}>
                <CustomTooltip title={val?.ToCity} data={val?.ToCity} placement={'bottom-start'} />
            </TableCell>
            <TableCell sx={{ height: '36px', textAlign: 'left', fontSize: '12px', minWidth: '80px', color: '#444', fontWeight: '500' }}>{moment(val.DispatchDate).format('DD-MMM-YY')}</TableCell>
            <TableCell sx={{ height: '36px', textAlign: 'right', fontSize: '12px', minWidth: '75px', color: '#444', fontWeight: '500' }}>{val.PaidAmt}</TableCell>
            <TableCell sx={{ height: '36px', textAlign: 'right', fontSize: '12px', minWidth: '75px', color: '#444', fontWeight: '500' }}>{val.ToPayAmt}</TableCell>
            <TableCell sx={{ height: '36px', textAlign: 'right', fontSize: '12px', minWidth: '75px', color: '#444', fontWeight: '500' }}>{val.Commission}</TableCell>
            <TableCell sx={{ height: '36px', textAlign: 'right', fontSize: '12px', minWidth: '75px', color: '#444', fontWeight: '500' }}>{val.ServiceChg}</TableCell>
            <TableCell sx={{ height: '36px', textAlign: 'right', fontSize: '12px', minWidth: '75px', color: '#444', fontWeight: '500' }}>{val.LoadingChg}</TableCell>
            <TableCell sx={{ height: '36px', textAlign: 'right', fontSize: '12px', minWidth: '75px', color: '#444', fontWeight: '500' }}>{val.UnLoadingChg}</TableCell>
            <TableCell sx={{ height: '36px', textAlign: 'right', fontSize: '12px', minWidth: '80px', color: '#444', fontWeight: '500' }}>
                {isEdit === index ?
                    <div className={'input--wrapper'} style={{ maxHeight: "25px", display: 'flex', alignItems: 'center', marginBottom: '0px' }}>
                        <LineinputV2
                            type="text"
                            id={`OthrChrgLess-${index}`}
                            autoFocus={true}
                            name="goods_value"
                            filter={getFloat}
                            value={updateData?.OtherChgManualLess}
                            onBlur={(event) => {
                                setUpdateData((prev) => ({
                                    ...prev,
                                    OtherChgManualLess: event.target.value
                                }))
                            }}
                            onKeyDown={(e) => {
                                navigation3(e, `OthrChrgAdd-${index}`, `add-${index}`, () => { })
                            }}
                        />
                    </div>
                    : val.OtherChgManualLess}
            </TableCell>
            <TableCell sx={{ height: '36px', textAlign: 'right', fontSize: '12px', minWidth: '80px', color: '#444', fontWeight: '500' }}>
                {isEdit === index ?
                    <div className={'input--wrapper'} style={{ maxHeight: "25px", display: 'flex', alignItems: 'center', marginBottom: '0px' }}>
                        <LineinputV2
                            type="text"
                            name="goods_value"
                            id={`OthrChrgAdd-${index}`}
                            filter={getFloat}
                            value={updateData?.OtherChgManualAdd}
                            onBlur={(event) => {
                                setUpdateData((prev) => ({
                                    ...prev,
                                    OtherChgManualAdd: event.target.value
                                }))
                            }}
                            onKeyDown={(e) => {
                                navigation3(e, `add-${index}`, `OthrChrgLess-${index}`, () => { })
                            }}
                        />
                    </div>
                    : val.OtherChgManualAdd}
            </TableCell>
            <TableCell sx={{ height: '36px', textAlign: 'right', fontSize: '12px', minWidth: '80px', color: '#444', fontWeight: '500' }}>{val.NetAmt}</TableCell>
            <TableCell sx={{ height: '36px', textAlign: 'left', fontSize: '12px', minWidth: '60px', color: '#444', fontWeight: '500', cursor: 'pointer' }}>
                {isEdit === index ?
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span id={`add-${index}`} tabIndex={0} style={{ marginRight: '8px' }}
                            onClick={() => {
                                setIsEdit('')
                                handleTableData({
                                    OtherChgManualLess: updateData?.OtherChgManualLess,
                                    OtherChgManualAdd: updateData?.OtherChgManualAdd,
                                }, index, val.VoucherNo)
                            }}
                            onKeyDown={(e) => {
                                navigation3(e, `close-${index}`, `OthrChrgAdd-${index}`, () => {
                                    setIsEdit('')
                                    handleTableData({
                                        OtherChgManualLess: updateData?.OtherChgManualLess,
                                        OtherChgManualAdd: updateData?.OtherChgManualAdd,
                                    }, index, val.VoucherNo)
                                    focusElemnt(`Print-${index}`)
                                })
                            }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 14.4C4.472 14.4 1.6 11.528 1.6 8C1.6 4.472 4.472 1.6 8 1.6C11.528 1.6 14.4 4.472 14.4 8C14.4 11.528 11.528 14.4 8 14.4ZM11.672 4.464L6.4 9.736L4.328 7.672L3.2 8.8L6.4 12L12.8 5.6L11.672 4.464Z" fill="#4CAF50" />
                            </svg>
                        </span>
                        <span id={`close-${index}`} tabIndex={0}
                            onClick={() => {
                                setIsEdit('')
                                setUpdateData({
                                    OtherChgManualLess: val?.OtherChgManualLess,
                                    OtherChgManualAdd: val?.OtherChgManualAdd,
                                })
                            }}
                            onKeyDown={(e) => {
                                navigation3(e, `OthrChrgLess-${index}`, `add-${index}`, () => {
                                    setIsEdit('')
                                    setUpdateData({
                                        OtherChgManualLess: val?.OtherChgManualLess,
                                        OtherChgManualAdd: val?.OtherChgManualAdd,
                                    })
                                    focusElemnt(`Print-${index}`)
                                })

                            }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M8 14.4C4.472 14.4 1.6 11.528 1.6 8C1.6 4.472 4.472 1.6 8 1.6C11.528 1.6 14.4 4.472 14.4 8C14.4 11.528 11.528 14.4 8 14.4ZM8 0C3.576 0 0 3.576 0 8C0 12.424 3.576 16 8 16C12.424 16 16 12.424 16 8C16 3.576 12.424 0 8 0ZM10.072 4.8L8 6.872L5.928 4.8L4.8 5.928L6.872 8L4.8 10.072L5.928 11.2L8 9.128L10.072 11.2L11.2 10.072L9.128 8L11.2 5.928L10.072 4.8Z" fill="#F44336" />
                            </svg>
                        </span>
                    </div>
                    : <span
                        id={`Edit-${index}`} tabIndex={0}
                        style={{ display: 'flex', color: '#007bfd', fontSize: '12px', fontWeight: '500' }}
                        onClick={() => {
                            setIsEdit(index)
                        }}
                        onKeyDown={(e) => {
                            navigation3(e, `Print-${index}`, index == 0 ? "loadbtn" : `Print-${index - 1}`, () => {
                                setIsEdit(index)
                            })
                        }}
                    >
                        <EditIcon sx={{ marginRight: '3px' }} />
                        Edit
                    </span>
                }
            </TableCell>
            <TableCell sx={{ height: '36px', textAlign: 'left', fontSize: '12px', minWidth: '60px', color: '#444', fontWeight: '500', cursor: 'pointer' }}>
                <span
                    id={`Print-${index}`} tabIndex={0}
                    style={{ display: 'flex', color: '#007bfd', fontSize: '12px', fontWeight: '500' }}
                    onClick={() => {
                        getPrintData(val?.VoucherNo)
                    }}

                    onKeyDown={(e) => {
                        navigation3(e, (tableData.length - 1) == index ? id.fromDate : `Edit-${index + 1}`, isEdit === index ? `close-${index}` : `Edit-${index}`, () => {
                            getPrintData(val?.VoucherNo)
                        })
                    }}

                >
                    <PrintIcon sx={{ marginRight: '3px' }} />
                    Print
                </span>
            </TableCell>
        </TableRow>
    )
}

export default CargoMemoBody